module.exports = __webpack_public_path__ + "static/media/ic-arrow-right.11c38995.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-arrow-right.svg
// module id = 596
// module chunks = 14